export enum SurveyWorkflowRoles {
    AccountManager = 'accountManager',
    Pilot = 'pilot',
    Inspector = 'inspector',
    Reporter = 'reporter',
    Validator = 'validator',
}
